module.exports = __webpack_public_path__ + "img/panel4.6b24d20b.jpg";